module.exports = __webpack_public_path__ + "img/05.288878c8.jpg";